import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../../components/Layout/ColumnLayout";
import { PartnerCommissions } from "../../../components/Reports/PartnerCommissions/PartnerCommissions";
import { Page } from "../../Page";

export const AgentCommissionsPage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/reports/distributionPartnersReconciliation");
    };

    return (
        <Page title="Distribution Partners Reconciliation Report">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>
                            Distribution Partners Reconciliation Report
                        </Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <PartnerCommissions />
            </ColumnLayout>
        </Page>
    );
};
